<div class="modal-header">
    <h5 class="modal-title" id="modal-basic-title">Permissions</h5>
    <button class="close" aria-label="Close" (click)="activeModal.dismiss()">
        <span aria-hidden="true">&times;</span>
    </button>
</div>

<div class="d-flex flex-column px-5 m-auto">
    <div class="row p-2">
        <span class="col-md-4"></span>
        @for (permission of permissions; track permission) {
            <div class="col-md-2 text-center">
                {{ permission?.permissionProfileString }}
            </div>
        }
    </div>

    <div class="row p-2">
        <div class="col-md-4">
            <span
                ngbTooltip="View Sites Associated to, complete Inventory Count, change Profile Contact Information, and view Notifications, MOU & Login History."
            >
                Core Features
            </span>
        </div>
        @for (permission of permissions; track permission) {
            <div class="col-md-2 text-center">
                @if (permission.coreFeatures) {
                    <fa-icon [icon]="faCheck"></fa-icon>
                }
            </div>
        }
    </div>

    <div class="row p-2">
        <div class="col-md-4">
            <span
                ngbTooltip="Create, Edit, Deactivate, Set Permissions equivalent or below that User, send Password Reset, Welcome Emails, 
				view Notifications and edit Associated Sites. Can only assign sites that are currently assigned to the Manager."
            >
                Manage Users for the Site
            </span>
        </div>
        @for (permission of permissions; track permission) {
            <div class="col-md-2 text-center">
                @if (permission.manageSiteUsers) {
                    <fa-icon [icon]="faCheck"></fa-icon>
                }
            </div>
        }
    </div>

    <div class="row p-2">
        <div class="col-md-4">
            <span ngbTooltip="Manage Site Business Days."> Change Site Business Days </span>
        </div>
        @for (permission of permissions; track permission) {
            <div class="col-md-2 text-center">
                @if (permission.siteBusinessDays) {
                    <fa-icon [icon]="faCheck"></fa-icon>
                }
            </div>
        }
    </div>

    <div class="row p-2">
        <div class="col-md-4">
            <span ngbTooltip="Create, Edit, but not Deactivate a Site."> Change Site Details </span>
        </div>
        @for (permission of permissions; track permission) {
            <div class="col-md-2 text-center">
                @if (permission.manageSites) {
                    <fa-icon [icon]="faCheck"></fa-icon>
                }
            </div>
        }
    </div>

    <div class="row p-2">
        <div class="col-md-4">
            <span
                ngbTooltip="Create, Edit, Deactivate, set Permissions equivalent or below that User, send Password Reset, Welcome Emails, view 
				Notifications and edit Associated Sites. Can assign sites and edit organization details that are currently assigned to the Managers' Organization."
            >
                Manage Users for the Org
            </span>
        </div>
        @for (permission of permissions; track permission) {
            <div class="col-md-2 text-center">
                @if (permission.manageOrgUsers) {
                    <fa-icon [icon]="faCheck"></fa-icon>
                }
            </div>
        }
    </div>

    <div class="row p-2">
        <div class="col-md-4">
            <span ngbTooltip="Ability to Deactivate a Site."> Deactivate a Site </span>
        </div>
        @for (permission of permissions; track permission) {
            <div class="col-md-2 text-center">
                @if (permission.deactivateSites) {
                    <fa-icon [icon]="faCheck"></fa-icon>
                }
            </div>
        }
    </div>

    <div class="row p-2">
        <div class="col-md-4">
            <span ngbTooltip="View all Sites Associated to the Users' Associated Organization.">
                View All Sites for the Org
            </span>
        </div>
        @for (permission of permissions; track permission) {
            <div class="col-md-2 text-center">
                @if (permission.viewAllSitesForOrg) {
                    <fa-icon [icon]="faCheck"></fa-icon>
                }
            </div>
        }
    </div>

    @if (isSysAdmin) {
        <div class="row p-2">
            <div class="col-md-4">
                <span ngbTooltip="View all Sites."> View All Sites </span>
            </div>
            @for (permission of permissions; track permission) {
                <div class="col-md-2 text-center">
                    @if (permission.viewAllSites) {
                        <fa-icon [icon]="faCheck"></fa-icon>
                    }
                </div>
            }
        </div>

        <div class="row p-2">
            <div class="col-md-4">
                <span ngbTooltip="Ability to Deactivate an Organization."> Deactivate an Org </span>
            </div>
            @for (permission of permissions; track permission) {
                <div class="col-md-2 text-center">
                    @if (permission.deactivateOrgs) {
                        <fa-icon [icon]="faCheck"></fa-icon>
                    }
                </div>
            }
        </div>

        <div class="row p-2">
            <div class="col-md-4">
                <span ngbTooltip="View Reports."> Reports </span>
            </div>
            @for (permission of permissions; track permission) {
                <div class="col-md-2 text-center">
                    @if (permission.reports) {
                        <fa-icon [icon]="faCheck"></fa-icon>
                    }
                </div>
            }
        </div>

        <div class="row p-2">
            <div class="col-md-4">
                <span ngbTooltip="Create, Edit, but not Deactivate all Organizations."> Add Organizations </span>
            </div>
            @for (permission of permissions; track permission) {
                <div class="col-md-2 text-center">
                    @if (permission.manageOrganizations) {
                        <fa-icon [icon]="faCheck"></fa-icon>
                    }
                </div>
            }
        </div>

        <div class="row p-2">
            <div class="col-md-4">
                <span ngbTooltip="View automated jobs."> View Quartz Jobs </span>
            </div>
            @for (permission of permissions; track permission) {
                <div class="col-md-2 text-center">
                    @if (permission.viewQuartzJobs) {
                        <fa-icon [icon]="faCheck"></fa-icon>
                    }
                </div>
            }
        </div>

        <div class="row p-2">
            <div class="col-md-4">
                <span
                    ngbTooltip="View NDC Database, Manage Help Documentation, Edit Release Notes, change User Notifications, and view Global Audit History."
                >
                    Admin Features
                </span>
            </div>
            @for (permission of permissions; track permission) {
                <div class="col-md-2 text-center">
                    @if (permission.adminFeatures) {
                        <fa-icon [icon]="faCheck"></fa-icon>
                    }
                </div>
            }
        </div>
    }

    <div class="mx-auto p-3">
        <button type="button" class="btn btn-cancel btn-lg" (click)="activeModal.dismiss()">Cancel</button>
    </div>
</div>
